export const initHero = () => {
  window.addEventListener('load', () => {
    document.body.classList.add('loaded');
  });
}
